/**
 * Mobile menu
 */
var component_mobile_menu = function(args) {

  // setup args
  var menu        = args.menu,
      site        = args.site,
      toggles     = args.toggles;


  // validate
  if (!menu || !site || !toggles.length) {
    console.log('Invalid mobile_menu args');
    return;
  }

  // menu dialog element
  var menu_dialog = menu.querySelector('#mobile-menu');

  // set toggle buttons aria-controls attribute
  var set_toggles_aria_controls = function(toggles) {
    for (var i = 0; i < toggles.length; i++) {
      toggles[i].setAttribute('aria-controls', menu_dialog.getAttribute('id'));
    }
  };

  set_toggles_aria_controls(toggles);

  // setup a11y dialog
  var dialog = new A11yDialog(menu, site);

  // tasks to open menu visually
  var open_menu = function() {

   document.body.classList.add('is-active-menu');

  };

  // tasks to close menu visually
  var close_menu = function() {

    document.body.classList.add('is-closing-menu');
    setTimeout(function() {
      document.body.classList.remove('is-active-menu');
      document.body.classList.remove('is-closing-menu');
     }, 200);

  };

  // set toggle buttons aria-expanded attribute
  var set_toggles_state = function(toggles) {
    setTimeout(function() {
      for (var i = 0; i < toggles.length; i++) {
        if (document.body.classList.contains('is-active-menu')) { // menu open
          toggles[i].setAttribute('aria-expanded', true);
        } else { // menu closed
          toggles[i].setAttribute('aria-expanded', false);
        }
      }
    }, 300);
  };

  // hooks
  dialog.on('show', function (element, event) {
    open_menu();
    set_toggles_state(toggles);
  });
  dialog.on('hide', function (element, event) {
    close_menu();
    set_toggles_state(toggles);
  });


  // toggle click
  var handle_toggle = function(e) {
    if (document.body.classList.contains('is-active-menu')) {
      dialog.hide();
    } else {
      dialog.show();
    }

  };

  for (var i = 0; i < toggles.length; i++) {
    toggles[i].addEventListener('click', handle_toggle, false);
  }

  // make the call chainable
  return this;

};
